<template lang="pug">
  .img.a-box-xs-1x1
    .a-box-content
      template(v-if="image.file_type == 'mp4'")
        img.full-width.v-center(:src="image.video_thumb" :alt="image.alt_text")
      template(v-else)
        img.full-width(:src="image.url" :alt="image.alt_text" itemprop="image")

</template>

<script>
  export default {
    name: "CarouselNavItem",

    props: {
      image: {
        type: Object,
        required: true,
        validator: function (value) {
          return (value.url || value.video_thumb) && value.alt_text;
        }
      }
    }
  };
</script>

<style scoped lang="stylus">
  .img
    border-radius 8px
    overflow hidden
    @media mq-tablet-less
      width 20vw


</style>